import { inject, Injectable } from '@angular/core';
import { IAppRequest } from '@app/app.interface';
import { IRegistryReportingDate } from '@modules/factor/children/scheduler/interfaces/sheduler.interface';
import { EFactorControllerUrl } from '@modules/factor/constains/factor.enumes';
import {
    TAutocompleteListRequestData,
    TAutocompleteListResponseRow,
    TCreateNewVersionList,
    TGetShedulerDatesData,
} from '@modules/factor/interfaces/factor-data-http-service.interface';
import { BaseHttpService } from '@services/http-base.service';
import { Observable, of, throwError } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class FactorDataHttpService {
    protected readonly http: BaseHttpService = inject(BaseHttpService);
    public readonly url = EFactorControllerUrl.factorData;

    /**
     * Создать новую версию данных
     * @param date - дата, на которую необходимо создавать новую версию
     * @param list - список FDid и их связей, с которых будут созданы данные на дату
     */
    public createNewVersion(date: string, list: TCreateNewVersionList[]): Observable<IAppRequest> {
        const data = {
            date,
            list,
        };
        const url = this.http.url + '/' + EFactorControllerUrl.factorData + '/createVersionBySchedulerDate';
        return this.http.client.post<IAppRequest>(url, data, this.http.options).pipe(
            take(1),
            switchMap((result) => {
                if (!result || (result.is_error && result.message)) {
                    return throwError(() => Error(result?.message));
                }
                return of(result);
            }),
        );
    }

    /**
     * Создать новую версию данных
     * @param date - дата, на которую необходимо создавать новую версию
     */
    public createNewVersionByRelationId(date: string, relationId: number): Observable<IAppRequest> {
        const data = {
            date,
            relationId,
        };
        const url =
            this.http.url + '/' + EFactorControllerUrl.factorData + '/createVersionByRelationIdAndSchedulerDate';
        return this.http.client.post<IAppRequest>(url, data, this.http.options).pipe(take(1));
    }

    /**
     * Получение данных реестра в виде списка с автодополнением.
     * @param data данные для фильтров
     */
    getAutocompleteList(data: TAutocompleteListRequestData): Observable<TAutocompleteListResponseRow[]> {
        return this.http.client.post<TAutocompleteListResponseRow[]>(
            this.http.url + '/factor_data/getAutocompleteList',
            data,
            this.http.options,
        );
    }

    /**
     * Получить список дат реестра (отчетные даты или даты на которые есть версии)
     * @param data - параметры для запроса
     */
    public getSchedulerDates(data: TGetShedulerDatesData): Observable<IRegistryReportingDate[]> {
        return this.http.client
            .post<IAppRequest>(
                this.http.url + '/' + EFactorControllerUrl.factorData + '/getSchedulerDates',
                data,
                this.http.options,
            )
            .pipe(
                take(1),
                switchMap((result) => {
                    if (result.is_error || !Array.isArray(result?.data)) {
                        return throwError(() => new Error(result?.message));
                    }
                    return of(result?.data);
                }),
            );
    }
}
